import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import validate from "validate.js";
import {
  rolesListFetch,
  hideUsersRoleValidationError,
  addUserRoles,
  redirectToUsersRoleList,
  gypsyballusersListFetch
} from "actions";
import RoleDropdown from "CommonComponent/RoleDropdown";
import { map } from "lodash";

const UpdateUserModal = (props) => {
  const { userName, userEmail, user_id, onHide } = props;
  const dispatch = useDispatch();

  const { usersListFetch, validation_error} =useSelector((state) => state.usersRoleState);

  const [roleValue, setRoleValue] = useState([]);
  const [formValid, setFormValid] = useState(false);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      userName: userName || "",
      userEmail: userEmail || "",
      user_id: user_id || "",
      role_id: [],
    },
    touched: {},
    errors: {},
  });

  useEffect(() => {
    if (!isEmpty(validation_error)) {
      setFormState((formState) => ({
        ...formState,
        isValid: false,
        errors: validation_error || {},
      }));
    } else {
      setFormState((formState) => ({
        ...formState,
        isValid: true,
        errors: {},
      }));
    }
  }, [validation_error]);

  useEffect(() => {
    const errors = validate(formState.values);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  // Effect to set initial values from props
  useEffect(() => {
    setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        userName: userName || "",
        userEmail: userEmail || "",
        user_id: user_id || "",
      },
    }));
  }, [userName, userEmail, user_id]);

  useEffect(() => {
    dispatch(rolesListFetch());
  }, [dispatch]);

  useEffect(() => {
    if(redirectToUsersRoleList){
      onHide();
    }
   
  }, [redirectToUsersRoleList]);

  // Fetch and set existing roles for the user
  useEffect(() => {
    if (user_id && Array.isArray(usersListFetch)) {
      const user = usersListFetch.find((user) => user.id === user_id);
      if (user && Array.isArray(user.roles)) {
        const roleOptions = user.roles.map((role) => ({
          value: role.id,
          label: role.name,
        }));
        setRoleValue(roleOptions);
        setRoleId(roleOptions);
      } else {
        setRoleValue([]);
        setRoleId([]);
      }
    }
  }, [user_id, usersListFetch]);

  const setRoleId = (roles) => {
    const role_ids = map(roles, "value");
    setFormState((prevState) => ({
      ...prevState,
      values: { ...prevState.values, role_id: role_ids },
      touched: { ...prevState.touched, role_id: true },
    }));
    dispatch(hideUsersRoleValidationError("role_id"));
    setFormValid(role_ids.length > 0);
  };

  // Handle validation errors from the server

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (formValid) {
      dispatch(addUserRoles(formState.values));
      onHide();
      dispatch(gypsyballusersListFetch())
    }
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field];

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="update-user-modal"
    >
      <Modal.Header className="justify-content-start">
        <Modal.Title id="contained-modal-title-vcenter">
          <h3 className="font-20 font-weight-s-bold heading-color">
            User Management Roles
          </h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="border-bottom-0">
        <Row>
          <Col lg={12}>
            <Form.Group className="mb-3" controlId="userName">
              <Form.Label className="font-13 font-weight-400 page-heading">
                User Name
              </Form.Label>
              <Form.Control
                type="text"
                value={formState.values.userName}
                className="input-field"
                readOnly
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group className="mb-3" controlId="userEmail">
              <Form.Label className="font-13 font-weight-400 page-heading">
                Email Address
              </Form.Label>
              <Form.Control
                type="email"
                value={formState.values.userEmail}
                className="input-field"
                readOnly
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group className="mb-3" controlId="role_id">
              <Form.Label className="font-13 font-weight-400 page-heading">
                Roles
              </Form.Label>
              <RoleDropdown
                RoleValue={roleValue}
                name="role_id"
                setRoleValue={setRoleValue}
                roleOnChange={(selectedRoles) => {
                  setRoleValue(selectedRoles || []);
                  setRoleId(selectedRoles || []);
                }}
                isMulti
                className={`input-field ${
                  hasError("role_id") ? "is-invalid" : ""
                }`}
              />
              {hasError("role_id") && (
                <Form.Control.Feedback type="invalid" className="d-block">
                  {formState.errors.role_id[0]}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="justify-content-start gap-4">
        <button
          className="n-u-btn"
          onClick={handleSubmit}
          disabled={!formValid}
        >
          Save
        </button>
        <button onClick={props.onHide} className="c-b-btn">
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateUserModal;
